/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".results-listing__price-toggle[_ngcontent-%COMP%]{margin:auto}.results-listing__price-learn_more_container[_ngcontent-%COMP%]{padding-left:44px}.results-listing__learn_more_link[_ngcontent-%COMP%]{color:#03a9f4;font-size:14px;cursor:pointer;font-family:Roboto,\"Helvetica Neue\",sans-serif}.results-listing__learn_more_link[_ngcontent-%COMP%]:active, .results-listing__learn_more_link[_ngcontent-%COMP%]:hover{font-weight:700}"];
export { styles as styles };
